import locationNotAssociated from './location_not_associated.component';

let locationNotAssociatedModule = angular.module('locationnotassociated', [
])

  .component('locationnotassociated', locationNotAssociated)

  .name;

export default locationNotAssociatedModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/location_not_associated/index.js